import api from '@/api/api'

class PushSubscriptionService {
  subscribe(token) {
    return api.axios.post('push-subscription/subscribe', {token});
  }
}

export default new PushSubscriptionService();
